import apiClient from './apiClient';
import { STRIPE_SESSION_INFO } from '../constants/UriConstants';
import { StripeSessionInfoInterface } from '../types/StripeSessionInfoInterface';

const getStripeSessionInfo = (sessionID: string): Promise<StripeSessionInfoInterface> =>
  apiClient.get(STRIPE_SESSION_INFO, { params: { session: sessionID } }).then((response) => response.data);

export default getStripeSessionInfo;
